import type { FormatMessageLike } from "./i18n/runtime";

export type SharedMarkdownEditorMessages = {
  emptyPreview: string;
  modes: {
    edit: string;
    split: string;
    preview: string;
  };
  toolbar: {
    heading: string;
    bold: string;
    italic: string;
    quote: string;
    bulletList: string;
    orderedList: string;
    link: string;
    codeBlock: string;
  };
  placeholders: {
    heading: string;
    bold: string;
    italic: string;
    quote: string;
    bulletList: string;
    orderedList: string;
    link: string;
    codeBlock: string;
  };
};

export function buildMarkdownEditorMessages(
  formatMessage: FormatMessageLike,
): SharedMarkdownEditorMessages {
  return {
    emptyPreview: formatMessage({ id: "common.markdownEditor.emptyPreview" }),
    modes: {
      edit: formatMessage({ id: "common.markdownEditor.modes.edit" }),
      split: formatMessage({ id: "common.markdownEditor.modes.split" }),
      preview: formatMessage({ id: "common.markdownEditor.modes.preview" }),
    },
    toolbar: {
      heading: formatMessage({ id: "common.markdownEditor.toolbar.heading" }),
      bold: formatMessage({ id: "common.markdownEditor.toolbar.bold" }),
      italic: formatMessage({ id: "common.markdownEditor.toolbar.italic" }),
      quote: formatMessage({ id: "common.markdownEditor.toolbar.quote" }),
      bulletList: formatMessage({ id: "common.markdownEditor.toolbar.bulletList" }),
      orderedList: formatMessage({ id: "common.markdownEditor.toolbar.orderedList" }),
      link: formatMessage({ id: "common.markdownEditor.toolbar.link" }),
      codeBlock: formatMessage({ id: "common.markdownEditor.toolbar.codeBlock" }),
    },
    placeholders: {
      heading: formatMessage({ id: "common.markdownEditor.placeholders.heading" }),
      bold: formatMessage({ id: "common.markdownEditor.placeholders.bold" }),
      italic: formatMessage({ id: "common.markdownEditor.placeholders.italic" }),
      quote: formatMessage({ id: "common.markdownEditor.placeholders.quote" }),
      bulletList: formatMessage({ id: "common.markdownEditor.placeholders.bulletList" }),
      orderedList: formatMessage({ id: "common.markdownEditor.placeholders.orderedList" }),
      link: formatMessage({ id: "common.markdownEditor.placeholders.link" }),
      codeBlock: formatMessage({ id: "common.markdownEditor.placeholders.codeBlock" }),
    },
  };
}
